
	
jQuery.noConflict();
var $ = jQuery;

/**
 * Retorna uma string sem espaços do valor enviado.
 * @param {string} valor
 */
function trim_null(valor){
	if(valor !== null && typeof valor !== 'undefined'){
		valor = ((valor+'').trim());
	}else{
		valor = '';
	}
	return valor;
}

function renderBannerLogin(){

	var banner = $('#banner').val();

	if(trim_null(banner) != ''){

		$('#foto-modelo').attr('src', banner);

	} else {

		$('#logo-section').css('background', 'none');

	}

}

(function($) {

	function gravarEmailRecuperacao() {

		function gravar() {

			var usuario = $('#usuario').val();
			var email = $('#email').val();

			var submitBtn = $('#submit-recover-email');

			//ajax
			var type	= "POST",
	            url		= "/password/email",
	            data	= {
					usuario: 	usuario,
	                email: 		email
	            },
	            success = function(data) {

					submitBtn.attr('disabled', true);

	            	showSuccess('O link para recuperar sua senha foi enviado para o e-mail '+email+'. Redirecionando para login...');

					setTimeout(function(){
						window.location.href = window.location.origin + '/auth/login';
					}, 3000);

	            }
	        ;

	        execAjax1(type, url, data, success);
	    }

	    function evento() {

	    	$('form')
	    		.submit(function(e) {
	    			e.preventDefault();
	    			gravar();
	    		})
	    	;

	    }

	    evento();

    }

	$(function() {

		gravarEmailRecuperacao();

	});

})(jQuery);